export { ProfilePageV2 } from "./ProfilePageV2";
